module.exports = __webpack_public_path__ + "static/christina-yacht-3-f4544085eaa6da7fa8ce3c339b2062dd.jpg";